import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, setInfo } from '@/utils/auth'
import { Message } from 'element-ui'
import { getInfo, getPageCode } from '@/api/user'
console.log(getPageCode)
// import pdd from '@/utils/pddpic'
// console.log(pdd)
// const protocol = window.location.protocol // 协议
// const host = window.location.host // 主机
// const reg = /^localhost+/
// let pather = ''
// if (reg.test(host)) {
//   // 若本地项目调试使用
//   pather = process.env.VUE_APP_BASE_API
// } else {
//   // 动态请求地址  协议  主机
//   pather = protocol + '//' + host
// }
NProgress.configure({ showSpinner: false }) // NProgress Configuration
let addRoutes = false

// eslint-disable-next-line space-before-function-paren
router.beforeEach(async (to, from, next) => {
  const hasToken = getToken()
  // const accessRoutes = await store.dispatch('permission/generateRoutes', ['*'])
  // console.log(accessRoutes)
  // const { user } = await store.dispatch('user/getInfo')
  // console.log(roles)
  const hasRoles = store.getters.roles && store.getters.roles.length > 0
  if (hasToken && hasRoles) {
    if (hasRoles) {
      // 当前有Token，有权限，表示初始化的加载流程已走完，第二次加载
      next()
    } else {
      // 加载有异常的情形
      try {
        store
          .dispatch('permission/generateRoutes', {
            roles: store.getters.roles,
            permissionCodeList: store.getters.routePermission
          })
          .then(accessRoutes => {
            if (!addRoutes) {
              router.addRoutes(accessRoutes)
              addRoutes = true
            }
            next({ ...to, replace: true })
          })
      } catch (error) {
        // remove token and go to login page to re-login
        await store.dispatch('user/resetToken')
        Message.error(error || 'Has Error')
        next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
    }
  } else if (to.path === '/login') {
    next()
    return
  } else {
    /* has no token, 第一次加载*/
    try {
      getInfo()
        .then(function (res) {
          const data = res.data
          if (data.code === 0) {
            // (async function() {
            //     try {
            //         // 获取 pagecode，可选
            //         const pageCode = await getPageCode({
            //             httpReferer: pather + to.path
            //         })
            //         console.log(pageCode)
            //         await PDD_OPEN_init({
            //             code: pageCode.data.data.pageCode // 上一步中拿到的 pagecode，可选
            //         })
            //         const pati = await window.PDD_OPEN_getPati()
            //         localStorage.setItem('pageCode', pageCode.data.data.pageCode)
            //         localStorage.setItem('pati', pati)
            //             // 使用 pati
            //         console.log(pati)
            //     } catch (e) {
            //         console.log(e)
            //     }
            // })()
            const userInfo = data.data
            console.log(userInfo)
            localStorage.setItem('userInfo', JSON.stringify(userInfo))
            // if (document.querySelector('meta[name="keywords"]')) {
            //     document.querySelector('meta[name="keywords"]').remove()
            //     document.querySelector('meta[name="description"]').remove()
            // }
            // const meta = document.createElement('meta')
            // meta.name = 'keywords'
            // const metad = document.createElement('meta')
            // metad.name = 'description'
            // meta.content = '1'
            // metad.content = '2'
            // document.getElementsByTagName('head')[0].prepend(meta)
            // document.getElementsByTagName('head')[0].prepend(metad)
            const ckToken = localStorage.getItem('token')
            if (!addRoutes && ckToken && !userInfo.token) {
              userInfo.token = ckToken
            }
            setInfo(userInfo)
            store
              .dispatch('user/setToken', {
                token: getToken(),
                name: userInfo.mall_name,
                roles: userInfo.roles,
                permission_version: userInfo.permission_version
              })
              .then(() => {
                // 加载权限信息
                store
                  .dispatch('permissionCode/initCodes', {
                    version: userInfo.permission_version,
                    roles: userInfo.roles
                  })
                  .then(({ roles, routePermission }) => {
                    store
                      .dispatch('permission/generateRoutes', {
                        roles: roles,
                        permissionCodeList: routePermission
                      })
                      .then(accessRoutes => {
                        router.addRoutes(accessRoutes)
                        // 权限处理完成后进行跳转
                        next({ ...to, replace: true })
                        NProgress.done()
                      })
                  })
              })
          } else {
            console.log('没拿到信息')
            NProgress.done()
            // location.href = '/login'
          }
        })
        .catch(e => {
          NProgress.done()
          console.log('未登录')
          // location.href = '/login'
        })
    } catch (e) {
      console.log('catch' + e)
      NProgress.done()
      location.href = '/login'
    }
  }

  next()
})

// router.beforeEach(async(to, from, next) => {
//     // start progress bar
//     NProgress.start()

//     // set page title
//     document.title = getPageTitle(to.meta.title)

//     // determine whether the user has logged in
//     // const hasToken = getToken()
//     const hasToken = localStorage.getItem('token')

//     if (hasToken) {
//         if (to.path === '/login') {
//             // if is logged in, redirect to the home page
//             next({ path: '/' })
//             NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
//         }
//     }
//     else {
//         // determine whether the user has obtained his permission roles through getInfo
//         // const hasRoles = store.getters.roles && store.getters.roles.length > 0
//         // console.log(hasRoles);
//         // if (hasRoles) {
//         //     next()
//         // }
//         // else {
//         //     try {
//         //         // get user info
//         //         // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
//         //         // const { roles } = await store.dispatch('user/getInfo')
//         //         // roles = ['*']
//         //         // generate accessible routes map based on roles
//         //         const accessRoutes = await store.dispatch('permission/generateRoutes', ['admin'])
//         //         console.log(accessRoutes);

//         //         // dynamically add accessible routes
//         //         router.addRoutes(accessRoutes)

//         //         // hack method to ensure that addRoutes is complete
//         //         // set the replace: true, so the navigation will not leave a history record
//         //         next({...to, replace: true })
//         //     } catch (error) {
//         //         // remove token and go to login page to re-login
//         //         // await store.dispatch('user/resetToken')
//         //         Message({
//         //                 type: 'error',
//         //                 message: error || "Has Error"
//         //             })
//         //             // Message.error(error || 'Has Error')
//         //         next(`/login?redirect=${to.path}`)
//         //         NProgress.done()
//         //     }
//         // }
//     }
// }
// else {
//     /* has no token*/

//     if (whiteList.indexOf(to.path) !== -1) {
//         // in the free login whitelist, go directly
//         next()
//     } else {
//         // other pages that do not have permission to access are redirected to the login page.
//         next(`/login?redirect=${to.path}`)
//         NProgress.done()
//     }
// }
// })

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
